<template>
    <div>
        <base-loading :visible="isLoading" />
        <div class="grid grid-cols-12 gap-4">
             <div class="col-span-4 md:col-span-4 md:col-start-1  xs:col-start-1">
               <vs-input :value="accountData.ClientName" disabled class="w-full"/>
            </div>
             <div class="col-span-2 md:col-span-2 md:col-start-5  xs:col-start-1">
               <vs-input :value="'*********' + accountData.account_suffix" disabled class="w-full" />
            </div>
            <div class="col-span-12 md:col-span-2 md:col-start-11  xs:col-start-1">
                <search-input v-model="search" @search="onSearch" @clear="onSearch" />
            </div>
            <div class="col-span-full col-start-1">
                <bank-account-reports-table 
                    :items="items" 
                    @loadMore="loadMore" 
                    @details="onDetails"
                    @sortChanged="onSortChanged" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useNotifier } from '@/composables/useNotifier'
import { useNavigator } from '@/composables/useNavigator'
import { useBankAccountReports } from '../../composables/useBankAccountReports'
import BankAccountReportsTable from './components/BankAccountReportsTable'
import BaseLoading from '@/views/app/components/BaseLoading'
import SearchInput from '@/views/app/components/SearchInput'

const { notify } = useNotifier()
const { goTo, getParam } = useNavigator()
const reports = useBankAccountReports()
const items = computed(() => reports.state.items)
const accountData = computed(() => reports.state.account)
const currentPage = computed(() => reports.state.currentPage)
const lastPage = computed(() => reports.state.lastPage)
const isLoading = computed(() => reports.state.loading)
const search = ref('')
const sort = ref({})
const account = getParam('account')

const loadData = async (params = {}) => {
    const payload = {
        page: reports.state.currentPage || 1,
        search: search.value,
        account: account.value,
        column: sort.value.column,
        order: sort.value.order,
        ...params
    }
    const result = await reports.getReports(payload)
    if (!result.success) notify({ title: 'error', text: 'message_error', color: 'danger' })
}

const loadMore = async () => {
    if (currentPage.value >= lastPage.value) return
    const newPage = reports.state.currentPage + 1
    await loadData({ page: newPage })
}

const onSearch = async () => {
    await loadData({ page: 1, search: search.value })
}

const onDetails = (row) => {
  goTo({ name: 'hsbc-bank-account-report-transactions', params: { report: row.id } })
}


const onSortChanged = async (sortData) => {
    sort.value.column = sortData.key
    sort.value.order = sortData.order
    await loadData({ column: sort.value.column, order: sort.value.order , page:1})
}

onMounted(() => loadData())

</script>
